import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";
import { IButtonVariant } from "@swiggy-private/dls-web-core/dist/components/Button/types";

export const PAYMENT_OPTIONS_CONSTANTS = {
    HEADER_TITLE: "Payment Options",
    OR_SEPARATOR: "OR",
};

export const IMAGES = {
    ICON_SIZE: 36,
    ALT_TEXT: "Payment Option Icon",
    CHECKMARK_ICON_SIZE: 16,
    CHECKMARK_ALT_TEXT: "Checkmark Icon",
};

export const PAYMENT_OPTIONS_ERROR_CONSTANTS = {
    DESCRIPTION_COLOR: "text_Med_Emphasis" as keyof IColors,
    CTA_BUTTON_TYPE: "primary" as IButtonVariant,
    IMAGE_WIDTH: "auto",
    SHOW_FULL_PAGE: false,
    SHOW_CTA: true,
};

export const LABEL_CONSTANTS = {
    BACK_BUTTON_ACCESSIBILITY_LABEL: "Go back",
};
